export default __webpack_public_path__ + "src/assets/ens-icon.bbdf41300e221c618a7ea2fe2ebc600a.svg";